import * as React from "react";

export type PopoverContext = {
    defaultRenderToBody?: boolean;
};
export const PopoverContext = React.createContext<PopoverContext>({ defaultRenderToBody: false });
